import React from 'react';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Switch from '@material-ui/core/Switch';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import CalendarToday from '@material-ui/icons/CalendarToday';
import Timelapse from '@material-ui/icons/Timelapse';

import { AddIcon, TrashIcon } from '../../../../images/icons/WrapSvg';

import Time from './Time.js';

function DetectError(arr) {
    let days = [];
    let result = false;
    // eslint-disable-next-line array-callback-return
    arr.map((time) => {
        // eslint-disable-next-line array-callback-return
        time.dow.map((day) => {
            if (days.indexOf(day) === -1) {
                days.push(day);
            } else {
                result = true;
            }
        });
    });
    return result;
}

class CardLocal extends React.Component {
    state = {
        idLocal: '',
        nombre: '',
        ruta: '',
        datosapertura: [],
        periodocomanda: '',
        aprobacionpropuesta: '',
        alertaprod: '',
        activo: false,
        validacionpropuesta: [],
    };

    static getDerivedStateFromProps(props, state) {
        if (props.local && props.id !== state.idLocal) {
            const {
                nombre,
                ruta,
                datosapertura,
                periodocomanda,
                aprobacionpropuesta,
                alertaprod,
                validacionpropuesta,
                activo,
            } = props.local;

            state.idLocal = props.id;
            state.activo = activo ? activo : false;
            state.nombre = nombre ? nombre : '';
            state.ruta = ruta ? ruta : '';
            state.datosapertura = datosapertura ? datosapertura : [];
            state.periodocomanda = periodocomanda ? periodocomanda : '';
            state.aprobacionpropuesta = aprobacionpropuesta ? aprobacionpropuesta : '';
            state.validacionpropuesta = validacionpropuesta ? validacionpropuesta : [];
            state.alertaprod = alertaprod ? alertaprod : '';

            return state;
        }
        return null;
    }

    handleClick = (event) => {
        const { datosapertura } = this.state;
        datosapertura.push({
            dow: [],
            apertura: '',
            cierre: '',
            aperturacocina: '',
            cierrecocina: '',
            fechainicio: '',
            fechafin: '',
        });
        this.props.onChange('datosapertura', datosapertura);
        this.setState({ datosapertura: datosapertura });
    };

    handleAddControl = (event) => {
        const { validacionpropuesta } = this.state;
        validacionpropuesta.push('');
        this.props.onChange('validacionpropuesta', validacionpropuesta);
        this.setState({ validacionpropuesta: validacionpropuesta });
    };

    handleChangevalidacionpropuesta = (value, index) => {
        const { validacionpropuesta } = this.state;
        validacionpropuesta[index] = value;
        this.props.onChange('validacionpropuesta', validacionpropuesta);
    };

    handleDeleteValidacionPropuesta = (index) => {
        const { validacionpropuesta } = this.state;
        validacionpropuesta.splice(index, 1);
        this.props.onChange('validacionpropuesta', validacionpropuesta);
        this.setState({ validacionpropuesta: validacionpropuesta });
    };

    handleChange = (event) => {
        this.props.onChange(event.target.name, event.target.value);
        this.setState({ [event.target.name]: event.target.value });
    };

    handleChangeDatosApertura = (name, value, index) => {
        const { datosapertura } = this.state;
        datosapertura[index][name] = value;
        this.props.onChange('datosapertura', datosapertura);
    };

    handleDeleteDatosApertura = (index) => {
        const { datosapertura } = this.state;
        datosapertura.splice(index, 1);
        this.props.onChange('datosapertura', datosapertura);
        this.setState({ datosapertura: datosapertura });
    };

    handleChecked = (event) => {
        this.props.onChange(event.target.name, event.target.checked);
        this.setState({ [event.target.name]: event.target.checked, edit: true });
    };

    render() {
        const { intl, info } = this.props;
        const {
            nombre,
            ruta,
            activo,
            datosapertura,
            periodocomanda,
            aprobacionpropuesta,
            alertaprod,
            validacionpropuesta,
        } = this.state;
        return (
            <Card className={'product_card'}>
                <CardContent>
                    <Grid container justify="center" className={'flex_grow_1 margin_top_24'}>
                        <Grid item xs={3} className="padding_top_24">
                            <div className="barlow_regular_small c_slate_grey upper margin_right_18 margin_top_12 text_align_right ">
                                {intl.formatMessage({ id: 'local_basic' })}
                            </div>
                        </Grid>
                        <Grid item xs={9} className="">
                            <div className="flex_full_column">
                                <div className="flex_full_row margin_bottom_12">
                                    <TextField
                                        fullWidth
                                        disabled={true}
                                        id={'nombre'}
                                        name={'nombre'}
                                        required
                                        label={intl.formatMessage({ id: 'local_name' })}
                                        className={'flex_full_row'}
                                        value={nombre}
                                        margin="normal"
                                    />
                                    <TextField
                                        fullWidth
                                        disabled={true}
                                        id={'ruta'}
                                        name={'ruta'}
                                        required
                                        label={intl.formatMessage({ id: 'local_zona' })}
                                        className={'margin_left_12 flex_full_row'}
                                        value={ruta}
                                        margin="normal"
                                    />
                                </div>
                            </div>
                        </Grid>
                        {info &&
                            info.security &&
                            info.security.totalPermits &&
                            info.security.totalPermits.some((f) => f === '20') && (
                                <React.Fragment>
                                    <Grid item xs={3} className="">
                                        <div className="barlow_regular_small margin_right_18 margin_top_12 text_align_right c_slate_grey upper">
                                            {intl.formatMessage({ id: 'local_active' })}
                                        </div>
                                    </Grid>
                                    <Grid item xs={9} className="">
                                        <div className="flex_full_column">
                                            <div className="flex_full_row margin_bottom_12">
                                                <Switch
                                                    name={'activo'}
                                                    checked={activo}
                                                    onChange={this.handleChecked}
                                                    value="lastWeek"
                                                    color="primary"
                                                />
                                            </div>
                                        </div>
                                    </Grid>
                                </React.Fragment>
                            )}
                        <Grid item xs={3} className="">
                            <div className="barlow_regular_small margin_right_18 margin_top_24 text_align_right c_slate_grey upper">
                                {intl.formatMessage({ id: 'local_alerts' })}
                            </div>
                        </Grid>
                        <Grid item xs={9} className="">
                            <div className="flex_full_column">
                                <div className="flex_full_row margin_bottom_12">
                                    <TextField
                                        id={'alertaprod'}
                                        name={'alertaprod'}
                                        required
                                        type="number"
                                        InputProps={{
                                            pattern: '[0-9]*',
                                        }}
                                        error={!(!alertaprod || parseInt(alertaprod, 10) >= 10)}
                                        helperText={
                                            alertaprod && parseInt(alertaprod, 10) < 10
                                                ? intl.formatMessage({ id: 'error_alertaprod' })
                                                : ''
                                        }
                                        label={intl.formatMessage({
                                            id: 'local_alertas_percentage',
                                        })}
                                        className={'flex_full_row'}
                                        value={alertaprod}
                                        onChange={this.handleChange}
                                        margin="normal"
                                        InputLabelProps={{}}
                                    />
                                </div>
                                <span className="flex_full_row margin_bottom_12 barlow_regular_small c_slate_grey">
                                    {intl.formatMessage({ id: 'local_alertas_text' })}
                                </span>
                            </div>
                        </Grid>
                        <Grid item xs={3} className="">
                            <div className="barlow_regular_small margin_right_18 margin_top_24 text_align_right c_slate_grey upper">
                                {intl.formatMessage({ id: 'local_aceptation' })}
                            </div>
                        </Grid>
                        <Grid item xs={9} className="">
                            <div className="flex_full_column">
                                <div className="flex_full_row margin_bottom_12 ">
                                    <TextField
                                        fullWidth
                                        id={'aprobacionpropuesta'}
                                        name={'aprobacionpropuesta'}
                                        required
                                        label={intl.formatMessage({ id: 'local_aceptation_label' })}
                                        value={aprobacionpropuesta}
                                        onChange={this.handleChange}
                                        margin="normal"
                                        type="time"
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <CalendarToday className="c_bluish" />
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </div>
                                <span className="flex_full_row margin_bottom_12 barlow_regular_small c_slate_grey">
                                    {intl.formatMessage({ id: 'local_aceptation_text' })}
                                </span>
                            </div>
                        </Grid>
                        <Grid item xs={3} className="">
                            <div className="barlow_regular_small margin_right_18 margin_top_12 text_align_right c_slate_grey upper">
                                {intl.formatMessage({ id: 'local_control' })}
                            </div>
                        </Grid>
                        <Grid item xs={9} className="">
                            <Grid container className={'flex_grow_1'}>
                                {validacionpropuesta &&
                                    validacionpropuesta.length > 0 &&
                                    validacionpropuesta.map((v, index) => {
                                        return (
                                            <Grid
                                                key={`validacionpropuesta-${index}`}
                                                item
                                                xs={6}
                                                className="padding_left_12 padding_right_12"
                                            >
                                                <TextField
                                                    fullWidth
                                                    label={intl.formatMessage({
                                                        id: 'local_aceptation_label',
                                                    })}
                                                    defaultValue={v}
                                                    onChange={(event) =>
                                                        this.handleChangevalidacionpropuesta(
                                                            event.target.value,
                                                            index,
                                                        )
                                                    }
                                                    margin="normal"
                                                    type="time"
                                                    InputProps={{
                                                        startAdornment: (
                                                            <InputAdornment position="start">
                                                                <CalendarToday className="c_bluish" />
                                                            </InputAdornment>
                                                        ),
                                                        endAdornment: (
                                                            <InputAdornment position="end">
                                                                <TrashIcon
                                                                    className="c_bluish hand"
                                                                    onClick={
                                                                        this
                                                                            .handleDeleteValidacionPropuesta
                                                                    }
                                                                />
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                />
                                            </Grid>
                                        );
                                    })}
                                <Grid item xs={6} className="">
                                    <div
                                        onClick={this.handleAddControl}
                                        className="flex_full_row margin_bottom_5 margin_top_12 padding_borders elements_center align_center barlow_medium_place_holder c_bluish uppercase hand"
                                    >
                                        <span>
                                            {intl.formatMessage({ id: 'local_add_control' })}
                                        </span>
                                        <AddIcon color="primary" className="icon" />
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <span className="barlow_regular_small c_slate_grey">
                                        {intl.formatMessage({ id: 'local_control_text' })}
                                    </span>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={3} className="">
                            <div className="barlow_regular_small margin_right_18 margin_top_12 text_align_right c_slate_grey upper">
                                {intl.formatMessage({ id: 'local_commands' })}
                            </div>
                        </Grid>
                        <Grid item xs={9} className="">
                            <div className="flex_full_column">
                                <TextField
                                    id={'periodocomanda'}
                                    name={'periodocomanda'}
                                    required
                                    label={intl.formatMessage({ id: 'local_lanzamientos_label' })}
                                    value={periodocomanda}
                                    onChange={this.handleChange}
                                    margin="normal"
                                    type="number"
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <Timelapse className="c_bluish" />
                                            </InputAdornment>
                                        ),
                                        pattern: '[0-9]*',
                                        style: { textAlign: 'center' },
                                        endAdornment: (
                                            <InputAdornment position="end">min</InputAdornment>
                                        ),
                                    }}
                                />
                            </div>
                            <span className="flex_full_row margin_bottom_12 barlow_regular_small c_slate_grey">
                                {intl.formatMessage({ id: 'local_commands_text' })}
                            </span>
                        </Grid>
                        <Grid item xs={3} className="">
                            <div className="barlow_regular_small margin_right_18 margin_top_12 text_align_right c_slate_grey upper">
                                {intl.formatMessage({ id: 'local_opening' })}
                            </div>
                        </Grid>
                        <Grid item xs={9} className="">
                            <div className="flex_full_column">
                                <div className="flex_full_row margin_bottom_5 margin_top_12 elements_center align_center barlow_medium_place_holder c_bluish">
                                    <Grid
                                        container
                                        justify="center"
                                        className={'flex_grow_1 shadow_down_only'}
                                    >
                                        <Grid item xs={4} className="" />
                                        <Grid
                                            item
                                            xs={4}
                                            className="c_slate_grey upper barlow_regular_small"
                                        >
                                            <FormattedMessage id="local_opening_local_header" />
                                        </Grid>
                                        <Grid
                                            item
                                            xs={4}
                                            className="c_slate_grey upper barlow_regular_small"
                                        >
                                            <FormattedMessage id="local_opening_kitchen_header" />
                                        </Grid>
                                        <Grid
                                            item
                                            xs={4}
                                            className="c_slate_grey upper barlow_regular_small"
                                        />
                                        <Grid
                                            item
                                            xs={2}
                                            className="c_slate_grey upper barlow_regular_small"
                                        >
                                            <FormattedMessage id="local_opening_open_header" />
                                        </Grid>
                                        <Grid
                                            item
                                            xs={2}
                                            className="c_slate_grey upper barlow_regular_small"
                                        >
                                            <FormattedMessage id="local_opening_close_header" />
                                        </Grid>
                                        <Grid
                                            item
                                            xs={2}
                                            className="c_slate_grey upper barlow_regular_small"
                                        >
                                            <FormattedMessage id="local_opening_kitchen_open_header" />
                                        </Grid>
                                        <Grid
                                            item
                                            xs={2}
                                            className="c_slate_grey upper barlow_regular_small"
                                        >
                                            <FormattedMessage id="local_opening_kitchen_close_header" />
                                        </Grid>
                                    </Grid>
                                </div>
                                {datosapertura &&
                                    datosapertura.length > 0 &&
                                    datosapertura.map((h, index) => (
                                        <div
                                            key={`datos-apertura-${index}`}
                                            className="flex_full_row margin_bottom_5 margin_top_12 elements_center align_center barlow_medium_place_holder c_bluish"
                                        >
                                            <Time
                                                info={h}
                                                index={index}
                                                onChange={this.handleChangeDatosApertura}
                                                onDelete={this.handleDeleteDatosApertura}
                                            />
                                        </div>
                                    ))}
                                {DetectError(datosapertura) && (
                                    <span className="barlow_regular_small c_lipstick">
                                        {intl.formatMessage({ id: 'error_hourly_open' })}
                                    </span>
                                )}
                                <div
                                    onClick={this.handleClick}
                                    className="flex_full_row margin_bottom_5 margin_top_12 padding_borders elements_center align_center barlow_medium_place_holder c_bluish uppercase dottedBox hand"
                                >
                                    <span>
                                        <FormattedMessage id="local_opening_add" />
                                    </span>
                                    <AddIcon color="primary" className="icon" />
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        );
    }
}

CardLocal.propTypes = {
    intl: intlShape.isRequired,
};

export default injectIntl(CardLocal);



// WEBPACK FOOTER //
// ./src/components/complex/inventory/local/Card.js